import React, { useEffect } from "react";
import { SignupURLV2 } from "../../../../types/common";
import { REDIRECT_AFTER_MS } from "../../constants";
import { useFormContext } from "../context/FormContext";
import { FF2EventName, trackFF2Event } from "../analytics";
import { Spinner } from "../../../Spinner";

export const RedirectToSignUpRemo: React.FC = () => {
  const { formData } = useFormContext();

  useEffect(() => {
    trackFF2Event(FF2EventName.REDIRECT_SIGNUP_REMO, formData);

    setTimeout(() => {
      window.location.href = `${AUTH_UI_URL}${SignupURLV2.REMORTGAGE}`;
    }, REDIRECT_AFTER_MS);
  }, []);

  return (
    <div className="heroff2-form">
      <h2>Great news!</h2>
      <h2>
        We can help you with remortgage. You will be redirected in
        {" "}
        {REDIRECT_AFTER_MS / 1000}
        {" "}
        seconds...
      </h2>
      <Spinner />
    </div>
  );
};
